export const TEXTS = {
  CONDUCTOR_STATUS: 'On',
  // Not "You have this claim": a status that names its reader is wrong for the colleague, team lead
  // or auditor reading the same claim.
  HANDLER_STATUS: 'Off',
  TAKE_OVER: 'Take over',
  HAND_BACK: 'Hand back',
  DIALOG_TITLE: 'Take over this claim?',
  DIALOG_BODY: 'Clive stops acting on this claim until you hand it back.',
  REASON_LABEL: 'Why?',
  CANCEL: 'Cancel',
  CONFIRM: 'Take over',
  /** What Clive is doing on the claim, shown in place of `CONDUCTOR_STATUS`, and the tooltip that explains it. */
  STATUS: {
    PREPARING: { text: 'Working', tooltip: 'Clive is starting on this claim' },
    RUNNING: { text: 'Working', tooltip: 'Clive is working on this claim' },
    WAITING_ON_EXPERTS: {
      text: 'Waiting on experts',
      tooltip: 'Waiting for expert opinions. Clive continues when they answer',
    },
    YIELDED: { text: 'Paused', tooltip: 'Clive paused and resumes on the next claim update' },
    PENDING_APPROVAL: { text: 'Pending approval', tooltip: 'An action is waiting for your approval' },
    ESCALATED: { text: 'Escalated', tooltip: 'Clive handed this claim back to you' },
    NEEDS_YOU: { text: 'Waiting for User', tooltip: 'Clive is waiting on your answer' },
    ERROR: { text: 'Action failed', tooltip: 'An action failed and Clive stopped' },
    INTERRUPTED: {
      text: 'Interrupted',
      tooltip: 'Clive stopped before finishing: it could not make further progress',
    },
    CRASHED: { text: 'Crashed', tooltip: 'Clive stopped unexpectedly' },
    COMPLETED: { text: 'Idle', tooltip: 'Clive finished. Nothing pending' },
    STOPPED: { text: 'Idle', tooltip: "Clive's last run was stopped by a take-over" },
    REPLIED: { text: 'Idle', tooltip: 'Clive answered a message. Nothing pending' },
    NOT_STARTED: { text: 'Not started', tooltip: 'Clive has not run on this claim yet' },
    UNKNOWN_ACTIVE: { text: 'Working', tooltip: 'Clive is working on this claim' },
    UNKNOWN_IDLE: { text: 'Idle', tooltip: 'Clive is not working on this claim' },
  },
};
